<div class="modal-header">
    <span class="modal-header-title">{{ 'DIALOG.SPECIFY_THE_REASON_FOR_REFUSAL' | translate }}</span>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>
<div class="modal-body">

    <form class="form" [formGroup]="form" autocomplete="off">

        <div class="form-group">
            <label class="filter-label"><span class="star">*</span> {{ 'DIALOG.SPECIFY_THE_REASON_FOR_REFUSAL' | translate }}({{ 'TEXT' | translate }})</label>
            <input type="text" class="form-control" id="reason" formControlName="reason">
        </div>
        <div class="form-group">
            <label class="filter-label"> {{ 'DIALOG.SPECIFY_THE_REASON_FOR_REFUSAL' | translate }}({{ 'FILE' | translate }})</label>
            <div class="row upload-file">
                <div class="col-3 upload-file-btn">
                    <div *ngIf="!file">
                        <ff-button-upload-files label="{{ 'UPLOAD_FILE' | translate }}" component="products"
                            (uploadedFiles)="uploadedFile($event)"></ff-button-upload-files>
                    </div>
                    <div *ngIf="file">
                        <button type="button" class="btn btn-light btn-sm clear-file-btn"
                            (click)="clearFile()">{{ 'DELETE' | translate }}</button>
                    </div>
                </div>
                <div class="col-9 uploaded-file-data">
                    <div *ngIf="file">
                        {{ file.name }}
                    </div>
                </div>
            </div>
        </div>

    </form>

</div>
<div class="modal-footer btn-box">
    <button type="button" class="btn btn-primary btn-sm" (click)="save()" [disabled]="form.invalid">{{ 'SAVE'| translate
        }}</button>
    <button type="button" class="btn btn-light btn-sm" (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate
        }}</button>
</div>